import React, { Component, Fragment } from "react";
import cx from "classnames";
import './index.scss';
class SingleSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBotMenuOpen: false,
    }
  }

  componentDidMount() {
    const { closeMenuOnScroll } = this.props;
    if (closeMenuOnScroll) {
      window.addEventListener("scroll", () => {
        if (this.state.isBotMenuOpen) {
          this.setState({
            isBotMenuOpen: false,
          })
        }
      });
    }
  }

  hideBotMenu = () => {
    if (this.state.isBotMenuOpen) {
      let element = document.getElementById("root");
      if (element) {
        element.addEventListener("click", this.hideBotMenuOnDocumentClick);
      }
    } else {
      let element = document.getElementById("root");
      if (element) {
        element.removeEventListener("click", this.hideBotMenuOnDocumentClick);
      }
    }
  }

  showBotOptions = () => {
    let { isBotMenuOpen } = this.state;
    this.setState({
      isBotMenuOpen: !isBotMenuOpen,
    }, () => {
      this.hideBotMenu()
    })
    if (this.props.onMenuOpen) {
      this.props.onMenuOpen();
    }
  }

  hideBotMenuOnDocumentClick = event => {
    let parent = event && event.target && event.target.parentElement.className;
    if ((
      parent &&
      parent.length &&
      (parent.indexOf('bot-select') < 0 &&
        parent.indexOf('header-bot-scroll') < 0))
      || parent === ''
    ) {

      this.setState({
        isBotMenuOpen: false
      }, () => { this.hideBotMenu() });
    } else if (event.target && event.target.src) {
      {
        this.setState({
          isBotMenuOpen: false
        }, () => { this.hideBotMenu() });
      }
    }
    if (this.props.onMenuClose) {
      this.props.onMenuClose();
    }
  }

  onDropdownChange = (item, custom = false) => {
    this.setState({
      isBotMenuOpen: false
    })
    this.props.onDropdownChange(item, custom)
  }

  onChange = (event) => {
    this.setState({
      isBotMenuOpen: true,
    })
  }

  render() {
    const { selectedValue, dropdownOptions, disabled, type, customClass, showHint, hintPrefix, hintObject, enableSort, sortValue, isCustom, fieldHintText } = this.props;
    const placeholderText = this.props.placeholder ? this.props.placeholder : "Select...";
    let value = (selectedValue && selectedValue.label) || '';
    return (
      <Fragment>
        <div data-testid="botDropdown" className="botDropdown">
          <div data-testid="inputBoxDiv-ellipsis" className="inputBoxDiv ellipsis"
            style={disabled ? { backgroundColor: "#f0f0f0", pointerEvents: 'none' } : {}} onClick={() => { if (!disabled) { this.showBotOptions() } }}>
            <input
              className={cx(' inputControl pointer ')}
              style={{ background: "transparent" }}
              type="text"
              onChange={this.onChange}
              disabled={disabled}
              placeholder={placeholderText}
              value={value}
              title={(selectedValue || {}).label || ''}
            />
            <span data-testid="arrow-wrapper" className="arrow-wrapper" >
              <i className="fa fa-angle-down" aria-hidden="true"></i>
            </span>
          </div>

          {this.state.isBotMenuOpen && (
            <div className='header-bot-list'>
              <div className="dropdown-menu dropdown-header-bot-box d-block">
                <div className={"scrollbar scrollbar-height header-bot-scroll conversationBotListDropdown"}>
                  {dropdownOptions && (dropdownOptions || []).map(item => {
                    return (<a key={item.value}
                      data-testid="dropdownoption"
                      className={cx('ellipsis dropdown-item dropdown-item-custom marT text-left ',
                        { 'active': item.value === ((selectedValue || {}).value || '') },
                        { [customClass]: customClass })} title={item.label}
                      id={`dd` + item.value}
                      onClick={() => this.onDropdownChange(item)}>{item.label}</a>)
                  })
                  }
                </div>
              </div>
            </div>

          )}
        </div>
      </Fragment>
    )
  }
}
export default SingleSelect;